export const ProductAvailability = {
  Available: 'Available',
  Released: 'Released',
  Future: 'Future',
  Retired: 'Retired',
};
